"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Display = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../components");
var displays = {
    b: "block",
    f: "flex",
    i: "inline",
    ib: "inline-block",
    if: "inline-flex",
};
var Display = function () { return (react_1.default.createElement(components_1.Section, { id: "display", notation: {
        base: "d",
        values: displays,
    }, title: "Display" })); };
exports.Display = Display;
